import { GridTypeMap, Grid as MaterialGrid } from '@mui/material';
import React, { FC, PropsWithChildren } from 'react';

type GridProps = GridTypeMap['props'] & { className?: string };

const Grid: FC<PropsWithChildren<GridProps>> = ({ children, ...muiGridProps }) => (
  <MaterialGrid container spacing={6} {...muiGridProps}>
    {children}
  </MaterialGrid>
);

export default Grid;
